import { useCurrentUser } from '@/database/hooks/hooks';
import ObjectFieldsSection from './ObjectFieldsSection';

const UserDocumentSection = () => {
  const { currentUser } = useCurrentUser();

  return <ObjectFieldsSection document={currentUser} title='User Document' />;
};

export default UserDocumentSection;
